export default "__VITE_ASSET__b844aa81__"